<template>
  <modal titulo="CNIB - Consulta de Documentos" :closeable="!rodando">
    <AlertBanner v-if="consulta" message="A consulta abaixo serve apenas para simples conferência, os indicadores ficam indisponíveis apenas com a importação do XML da CNIB para dentro do sistema"/>

    <card :title="processo">
      <card-content>

        <p class="text-center" v-html="processo"></p>

        <template v-if="erros && erros.length">
          <p class="text-danger mb-2"><b>Erros retornados [{{erros.length}}]:</b></p>
          <ul class="pl-4">
            <li v-for="erro in erros" v-html="erro" :key="erro"></li>
          </ul>
        </template>

        <template v-if="resultados && resultados.length">

          <div v-for="resultado in resultados" :key="resultado.hash" class="alert my-2"
               :class="{'alert-outline-success' : resultado.valido, 'alert-outline-danger' : !resultado.valido}">

            <p><b>Documento:</b> {{resultado.documento}}</p>
            <p><b>Hash:</b> {{resultado.hash}}</p>
            <p v-if="resultado.dataConsulta"><b>Data da consulta:</b> {{resultado.dataConsulta}}</p>
            <p v-if="resultado.resultado"><b>Resultado:</b> {{resultado.resultado === 'POSITIVA' ? 'Positiva (com indisponibilidade)' : 'Negativa (sem indisponibilidade)'}}</p>
            <p class="pb-0">
              {{resultado.mensagem}}
              <template v-if="resultado.protocolos && resultado.protocolos.length">{{resultado.protocolos.join(', ')}}</template>
            </p>

          </div>

        </template>

      </card-content>
    </card>

    <template #footer>

      <button type="button" v-if="rodando" :disabled="true" class="btn btn-primary ml-auto mr-auto">
        <small-loading :loading="true" style="display: inline-block; margin-top: 5px; margin-bottom: 0 !important;" color="text-white" class="mb-1">
        </small-loading>
      </button>

      <template v-if="!rodando">

        <button type="button" class="btn btn-outline-primary mr-auto" @click="close">
            Fechar Consulta
        </button>

        <v-button v-if="!consulta" class="btn btn-outline-warning" :run="atualizar" :popover="true">
          Atualizar Envolvidos
        </v-button>

      </template>

    </template>

  </modal>
</template>

<script>
import ArispBusiness from "@/business/ArispBusiness.js";
import FrontBusiness from "@/business/FrontBusiness.js";
import AlertBanner from "@/components/alert/AlertBanner.vue";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";
import SmallLoading from "@/components/SmallLoading.vue";

export default {
    name: "CnibPesquisaDocumento",
    components: {SmallLoading, CardContent, Card, Modal, AlertBanner},
    props: {
      protocolo: String,
      documentos: Array,
      indicadorReal: { type: String, default: null },
      consulta:  {type : Boolean, default: () => false},
    },

    modal:{
      width: 900,
      escapable: false
    },

    data() {
      return {
        contador:{
          total: 0,
          atual: 0
        },
        processo: null,
        pedidos : null,
        erros: [],
        rodando: false,
        resultados: []
      }
    },

    mounted() {
      this.iniciar();
    },

    methods: {

      close(){
        FrontBusiness.closeModal();
      },

      async atualizar(){

        const dados = this.resultados
          ?.filter(e => e.hash)
          .map(e => ({
            documento: e.documento,
            hash: e.hash,
            dataConsulta: e.dataConsulta,
            resultado: e.resultado
          }));

        let r = await this.$api.post(`api/v2/cnib/atualizar-protocolo/${this.protocolo}`, dados)
          .catch(e => this.mostrarErro(null, e));

        if(r){
          FrontBusiness.showSuccess('', 'Envolvidos atualizados com sucesso')
          FrontBusiness.closeModal(true);
        }

      },

      async mostrarErro(pedido, e){
        this.erros.push(`<b>Erro: </b> ${e?.message || e}`);
        return null;
      },

      async modeloV2(){

        this.$set(this, 'rodando', true);
        this.contador.atual = 0;

        this.processo = "Iniciando consulta";
        let response;
        if (this.documentos && this.documentos.length) {
          response = await ArispBusiness.consultarHashsCnibDocumentos(this.documentos).catch(e => this.mostrarErro(null, e));
        } else if (this.indicadorReal) {
          response = await ArispBusiness.consultarHashsCnibIndicadorReal(this.indicadorReal).catch(e => this.mostrarErro(null, e));
        } else {
          response = await ArispBusiness.consultarHashsCnibProtocolo(this.protocolo).catch(e => this.mostrarErro(null, e));
        }
        console.debug('response', response);

        this.processo = "Consulta finalizada";

        this.$set(this, 'resultados', response);
        this.$set(this, 'rodando', false);

      },

      async iniciar(){
        await this.modeloV2();
      }
    }

  }
</script>
